module.exports = __webpack_public_path__ + "static/img/famingzhuanli.7b5601e4.jpg";